import { Component,OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ReferralDataService } from '../../services/referral-data.service';
import { SectionsService } from '../../services/sections.service';
import { AuthorizationUtility } from '../../shared/authorization/auth.utility';
import { AuthorizeButtonDirective } from '../../shared/authorization/authorizeButton.directive';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { PAGE_CONSTANTS, PAGE_AVAILABLE_ACTIONS } from '../../shared/constants/page.constants';
import { STATIC_DATA } from '../../shared/constants/static-data.constants';
import { SharedDataService } from '../../shared/services/shared-data-service';
import { BaseComponent } from '../../shared/utils/base.component';
import { AllowListAuthStore } from '../../shared/authorization/allow-list-auth.store';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'ppl-participant-leads-list',
  standalone: true,
  imports: [ListTableComponent, NzIconModule, NzButtonModule, RouterModule, AuthorizeButtonDirective, ButtonComponent],
  templateUrl: './participant-leads-list.component.html',
  styleUrl: './participant-leads-list.component.css'
})
export class ParticipantLeadsListComponent extends BaseComponent implements OnInit{
  title = 'List of all Participant Interest';
  programName!: string;
  lazyLoad = true;
  sharedDataKey: string = STATIC_DATA.SHARED_PARTICIPANT_LEADS_DATA;
  pageId: string = PAGE_CONSTANTS.PARTICIPANT_LEADS_DATA_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isReadOnly = false;
  isPageRestrictionLoaded = false;

  constructor(protected router: Router,
    protected sectionService: SectionsService,
    protected referralDataService: ReferralDataService,
    protected sharedDataService: SharedDataService,
    protected userService: UserService,
    private authUtility: AuthorizationUtility,
    protected allowListStore: AllowListAuthStore) {
    super();
   }

  ngOnInit() {
    this.sectionService.removeEnrollmentType();
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    const availableActions = PAGE_AVAILABLE_ACTIONS[this.pageId] ?? [];
    if (availableActions.length > 0 && authConfig?.pages[this.pageId]) {
      const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
      this.actionsToBeHidden = availableActions.filter(
        action => !allowedActions.some(aa => aa.toLowerCase() === action.toLowerCase())
      );
    }
    // No page config in auth = view-only
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }

  onNewLead() {
    if (this.isReadOnly) return;
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('participants');
    this.referralDataService.clearReferrralData();
  }

  rowClicked(rowDetail: { lead_participant_id: string; }) {
    console.log(rowDetail);

   this.userService.setLeadEntry('participant');
    this.userService.setSelectedLead(rowDetail.lead_participant_id);
    setTimeout(() => {
      this.router.navigate(['/home/participantLeadsList/leadDetails/']);
    }, 200)    
  }

  returnClicked(): void {
    this.router.navigate(['/home/participantLeadsList']);
  }
}
